import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ResetPasswordState {
  username: string;
  token?: string;
  passResetToken?: string;
  uid?: string;
}

const initialState: ResetPasswordState = {
  username: "",
  // token: "",
  // uid: "",
};

const resetPasswordSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setAuthData(state, action: PayloadAction<{ username: string; }>) {
      state.username = action.payload.username;
      // state.token = action.payload.token;
      // state.uid = action.payload.uid;
    },
    clearAuthData(state) {
      state.username = "";
      // state.token = "";
      // state.uid = "";
    },
    setPassResetToken(state, action: PayloadAction<{ token: string }>) {
      state.passResetToken = action.payload.token
    }
  },
});

export const { setAuthData, clearAuthData, setPassResetToken } = resetPasswordSlice.actions;
export default resetPasswordSlice.reducer;
